(function () {
  'use strict';

  function initTabs(root) {
    const tabs = root.querySelectorAll('[data-lc-tab]');
    const panels = root.querySelectorAll('[data-lc-tab-panel]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const target = tab.dataset.lcTab;
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.lcTabPanel !== target;
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-lc-product-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('[data-lc-product-tabs]');
    if (root) initTabs(root);
  });
})();
